<template>
  <div>
    <div class="titleAfter">能量分析</div>
    <div class="item-status">当前状态：健康积极</div>
    <div class="item-info">
      正能量包含自信、自我调节、平衡，负能量包含激动、压力、不安，生理能量包含抑制、神经质，正负能量越来越低时，表明处于健康状态。
    </div>
    <div style="display: flex">
      <div style="color: #fb6049">建议：</div>
      <div style="flex: 1; line-height: 1.5">
        <span>正能量不能 < 40%</span><br />
        <span>负能量不能 > 40%</span><br />
        <span>生理量不能 > 20%</span>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  font-weight: bold;
  color: #4aefff;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -8px;
  top: 2px;
  width: 3px;
  height: 14px;
  background: #4aefff;
  border-radius: 38px 38px 38px 38px;
}
.item-status {
  margin: 10px 0 20px 0;
}
.item-info {
  line-height: 26px;
  margin-bottom: 20px;
}
</style>
